import { type ExpenseMileageConfigurationConstructor } from '@webapp/modules/expense/entities/ExpenseMileageConfiguration'
import { mapMileageRatePresetApiModel } from './mapMileageRatePresetApiModel'
import { type ExpenseMileageConfigurationApiModel } from '../api-models/ExpenseMileageConfigurationApiModel'

export const mapExpenseMileageConfigurationApiModel = (
  apiModel: ExpenseMileageConfigurationApiModel
): ExpenseMileageConfigurationConstructor => ({
  forcePresetRates: apiModel.value.force_preset_rates,
  taxType: apiModel.value.tax_type,
  defaultMileagePreset: apiModel.value.default_mileage_preset
    ? mapMileageRatePresetApiModel(apiModel.value.default_mileage_preset)
    : null,
})
